import React, { Suspense, useContext, useEffect } from "react";
import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import LsLoading from "Components/LsLoading";
import { MemberGroupInvitationStatus, SavedSearchSourceType } from "Services/API/API";
import { Main } from "./Main";
import { Dashboard } from "../../Dashboard/Page";
import { Collections } from "../../Collections/Page";
import { Venues } from "../../Collections/Venues";
import { Reservations } from "../../Reservations/Page";
import { Settings } from "../../Settings/Page";
import { Help } from "../../Help/Page";
import { Workspaces } from "../../Collections/Workspaces";
import AccountContext from "../../../AccountContext";
import UserContext from "../../../UserContext";
import { SocialCollaboration } from "../../SocialCollaboration";
import { DesignContextProvider } from "Components/DesignContext";

const OnboardingPage = React.lazy(() => import("../../Onboarding"));
const Messages = React.lazy(() => import("../../Messages/Page"));
const Chain = React.lazy(() => import("../../Messages/Chain"));

interface Mobility3RoutesProps {
   accountUrl: string
}

const Mobility3Routes: React.FC<Mobility3RoutesProps> = ({ accountUrl }) => {
   const { user, enterpriseUser } = useContext(UserContext);
   const account = useContext(AccountContext);
   const addReturnPathToSearch = (search: string, pathname: string) => {
      const query = new URLSearchParams(search);
      if (pathname != "/")
         query.append("returnPath", pathname);
      return query.toString();
   }

   //set disign at top level for elements rendered at body via createPortal
   useEffect(() => {
      const originalDesign = document.body.dataset["design"];
      document.body.dataset["design"] = "primary";
      return () => { document.body.dataset["design"] = originalDesign; }
   }, []);

   return <BrowserRouter basename={accountUrl}>
      <Switch>
         <Route path="/signin" >
            <Suspense fallback={<LsLoading isLoading={true} />}>
               <DesignContextProvider name="marketing">
                  <OnboardingPage />
               </DesignContextProvider>
            </Suspense>
         </Route>
         <Route render={(props) => {
            return user.isAuthenticated && ((enterpriseUser.invitationStatus == MemberGroupInvitationStatus.Active && enterpriseUser.homeBaseSearchType == SavedSearchSourceType.BrandedPortal) || user.isSuperUser)
               ? <DesignContextProvider name="primary">
                  <Main>
                     <Switch>
                        <Route path="/main" component={Dashboard} />
                        {(account.socialCollaborationPortalEnabled || user.isSuperUser) && <Route path="/social" component={SocialCollaboration} />}
                        {/* <Route path="/search" component={Search} /> */}
                        <Route path="/collections" component={Collections} />
                        <Route path="/workspaces/:id" render={({ match: { params: { id } } }) => <Workspaces id={id} />} />
                        <Route path="/venues/:id" render={({ match: { params: { id } } }) => <Venues id={id} />} />
                        <Route path="/reservations" component={Reservations} />
                        <Route path={`/messages/:id(${Guid.PATTERN})`} render={({ match: { params: { id } } }) => <Chain id={id} />} />
                        <Route path="/messages" component={Messages} />
                        <Route path="/settings" component={Settings} />
                        <Route path="/help" component={Help} />
                        <Route>
                           <Redirect to={{ pathname: "/main", search: props.location.search }} />
                        </Route>
                     </Switch>
                  </Main>
               </DesignContextProvider>
               : <Redirect to={{ pathname: "/signin", search: addReturnPathToSearch(props.location.search, props.location.pathname) }} />
         }
         } />
      </Switch>
   </BrowserRouter>
}

export default Mobility3Routes;